module.exports = __webpack_public_path__ + "static/img/3a.92c1f8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3a.jpg
// module id = CABN
// module chunks = 1